import { FieldBase } from '@/domain/mitarbeiter/shared/components/form/fieldComponents/FieldBase';
import { useFieldContext } from '@/domain/mitarbeiter/shared/components/form/hooks';
import { FieldProps } from '@/domain/mitarbeiter/shared/components/form/types';
import { InputDatePicker } from '@e2n/ui/v2';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

type DatePickerValueFormat = 'iso' | 'date';

function toFieldValue(
  date: Date | undefined,
  valueFormat: DatePickerValueFormat,
) {
  if (valueFormat === 'date') {
    return date;
  }

  return date ? dayjs(date).toISOString() : null;
}

export function DatePickerInput({
  label,
  isRequired,
  description,
  className,
  disabled,
  infoText,
  placeholder,
  valueFormat = 'iso',
  ...props
}: FieldProps & {
  valueFormat?: DatePickerValueFormat;
}) {
  const field = useFieldContext<Date | string | null | undefined>();
  const { t } = useTranslation();

  return (
    <FieldBase
      label={label}
      isRequired={isRequired}
      description={description}
      className={className}
      infoText={infoText}
      {...props}>
      <InputDatePicker
        id={field.name}
        name={field.name}
        value={
          field.state.value ? dayjs(field.state.value).toDate() : undefined
        }
        onChange={(d) => field.handleChange(toFieldValue(d, valueFormat))}
        onBlur={field.handleBlur}
        disabled={disabled}
        placeholder={placeholder ?? t('general.date.dateInput.placeholder')}
      />
    </FieldBase>
  );
}
